export default __webpack_public_path__ + "static/blob3-df08cf5d6a4271b95fe53eafe981261f.svg";